<script lang="ts">
	import { Hint } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	import type { ComponentType } from '@wiseed/wikit';
	import { DynamicComponent } from '@wiseed/wikit';
	import { goto } from '$app/navigation';
	import { attrValue } from '@wiseed/wikit';

	export let label: string | null = null;
	export let value: string | ComponentType;
	export let hint: string | null = null;
	export let url: string | null = null;
	export let classNames: string;

	let handleClick = () => {
		if (url) {
			goto(url);
		}
	};
</script>

<div class={attrValue(['flex flex-col justify-between text-center items-center', classNames])}>
	{#if value}
		{#if typeof value == 'string'}
			<div class="font-bold first-letter:uppercase">{@html value}</div>
		{:else}
			<DynamicComponent component={value} />
		{/if}
	{:else}
		<slot />
	{/if}
	<div class="inline-flex items-center">
		{#if label}
			<div class="font-light first-letter:uppercase" class:mr-3={!!hint}>{@html label}</div>
		{/if}
		{#if hint}
			<Hint tooltip={{ content: capitalize(hint) }} on:click={() => handleClick()} />
		{/if}
	</div>
</div>
